var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlValetServiceFilled = function SvgHtlValetServiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.516 14.997a.5.5 0 0 1-.5-.5v-2.71a2.66 2.66 0 0 1 .725-1.785 2.954 2.954 0 0 1 2.189-.787h4.191a2.954 2.954 0 0 1 2.242.815c.436.485.67 1.118.653 1.77v2.7a.5.5 0 0 1-.461.5h-.039l-9-.003Zm4.485-3 2-2h-4l2 2ZM4.919 5.314c0-.328.055-.653.163-.963a.991.991 0 0 1-.066-.357V1.997a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-.066.356c.108.31.163.637.162.965a3.1 3.1 0 0 1-6.194 0v-.004Zm1 0a2.1 2.1 0 0 0 4.194 0c0-.108-.01-.216-.027-.323H5.946a1.9 1.9 0 0 0-.028.326v-.003Z"
  })));
};
export default SvgHtlValetServiceFilled;